import { type MouseEvent } from "react";
import { Link } from "react-router";

import { Box, Card, Typography } from "@mui/material";

import { theme } from "@/src/theme/theme";

import PageContainer from "@/src/components/atoms/PageContainer";

import { Article, formatArticleDate } from "@/src/utils/blogUtils";

export interface ArticleTopCardProps {
  articleData: Article;
  onClick: (e: MouseEvent) => void;
  to: string;
}

const ArticleTopCard = ({ articleData, to, onClick }: ArticleTopCardProps) => {
  const titleStyle = {
    color: theme.palette.text.primary,
    textAlign: "center",
    width: "100%",
    position: "absolute",
    bottom: -10,
    left: "50%",
    zIndex: "4",
    transform: "translateX(-50%)",
    mb: 0,
    pb: 0,
    px: "10%",
    "&.MuiTypography-root": {
      fontStyle: "italic",
      lineHeight: 1.25
    }
  };

  return (
    <Link to={to} prefetch="intent" style={{ textDecoration: "none" }}>
      <Card
        component="article"
        sx={{
          boxShadow: "none",
          background: "none",
          marginBottom: 2,
          "*": {
            cursor: "pointer !important"
          }
        }}
        onClick={onClick}
      >
        <Box
          sx={{
            position: "relative",
            width: "100%",
            aspectRatio: "16 / 9",
            minHeight: "200px",
            marginBottom: 2
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: "100%",
              height: "100%",
              maskImage: `linear-gradient(${theme.palette.common.black} 30%, transparent)`,
              WebkitMaskImage: `linear-gradient(${theme.palette.common.black} 30%, transparent)`
            }}
          >
            <img
              src={articleData.mainImage?.url}
              alt={
                articleData.mainImage?.caption ||
                articleData.title ||
                "Article image"
              }
              width={800}
              height={450}
              loading="eager"
              decoding="async"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: theme.shape.borderRadius
              }}
            />
          </Box>
          <Typography component="h2" variant="h3" sx={titleStyle}>
            {articleData.title}
          </Typography>
        </Box>
        <PageContainer>
          <Box>
            <Typography variant="subtitle2">{articleData.ingress}</Typography>
          </Box>
          <Typography
            variant="subtitle3"
            sx={{
              color: theme.palette.text.secondary,
              marginTop: 0.25
            }}
          >
            {formatArticleDate(articleData.date)}
          </Typography>
        </PageContainer>
      </Card>
    </Link>
  );
};

export default ArticleTopCard;
